/* 🤖 this file was generated by svg-to-ts */
export const matIconDoubleArrow: {
  name: 'double-arrow';
  data: string;
} = {
  name: 'double-arrow',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M15.5 5H11l5 7-5 7h4.5l5-7z"/><path d="M8.5 5H4l5 7-5 7h4.5l5-7z"/></svg>`
};
